
import {
  getVideoPlayUrl,
  getVideoResolve
} from '@/components/gallery/gallery.service'
import { VideoResolve, Videos } from '@/models'
import moment from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class GalleryFile extends Vue {
  public id: string | null = null
  public videoResolve = {} as VideoResolve
  public currentVideo = {} as Videos
  public videos: Videos[] = []
  public isLoaded = false
  public videoSource = ''
  loading = false
  playUrl: string | null = null
  error: string | null = null

  // to avoid infinite refresh loops
  private refreshAttempted = false

  mounted() {
    this.loadPlayUrl()
  }

  @Watch('id')
  async onVideoIdChanged() {
    this.refreshAttempted = false
    await this.loadPlayUrl()
  }

  get playerEl(): HTMLVideoElement | null {
    return (this.$refs.player as HTMLVideoElement) || null
  }

  async loadPlayUrl(): Promise<void> {
    this.loading = true
    this.error = null

    try {
      const { url } = await getVideoPlayUrl(this.id)
      this.playUrl = url

      // Reset refresh guard when a new URL is loaded
      this.refreshAttempted = false

      // Force reload of the element if it already existed
      this.$nextTick(() => {
        const v = this.playerEl
        if (v) v.load()
      })
    } catch (e) {
      this.playUrl = null
      this.error = this.normalizeError(e)
    } finally {
      this.loading = false
    }
  }

  async onVideoError(): Promise<void> {
    const v = this.playerEl
    if (!v) return

    // If SAS expired, browser often throws a generic media error.
    // We do one refresh attempt.
    if (this.refreshAttempted) {
      this.error = 'Video could not be loaded. Please try again.'
      return
    }

    this.refreshAttempted = true

    const resumeAt = Number.isFinite(v.currentTime) ? v.currentTime : 0
    const wasPlaying = !v.paused

    try {
      const { url } = await getVideoPlayUrl(this.id)
      this.playUrl = url

      this.$nextTick(async () => {
        const vv = this.playerEl
        if (!vv) return

        vv.load()

        // Wait for metadata so currentTime can be set safely
        const onLoaded = () => {
          vv.removeEventListener('loadedmetadata', onLoaded)

          try {
            vv.currentTime = resumeAt
          } catch {
            // some browsers can reject if not seekable yet; ignore
          }

          if (wasPlaying) {
            vv.play().catch(() => {
              console.log(
                'Autoplay failed after refresh; user interaction may be required.'
              )
            })
          }
        }

        vv.addEventListener('loadedmetadata', onLoaded)
      })
    } catch (e) {
      this.error = this.normalizeError(e)
    }
  }

  private normalizeError(e: any): string {
    const msg =
      e?.response?.data?.error ||
      e?.response?.data?.message ||
      e?.message ||
      'Unexpected error.'
    return typeof msg === 'string' ? msg : 'Unexpected error.'
  }

  async created() {
    // fetch(process.env.BASE_URL + 'config2.txt')
    //   .then(res => res.json())
    //   .then(data => {

    //   })
    this.videoSource = `${process.env.VUE_APP_GALLERY}?id=${this.$route.params.id}#t=0.1`
    await this.getVideos()
  }

  async getVideos() {
    this.id = this.$route.params.id
    this.videoResolve = await getVideoResolve(+this.id)
    this.currentVideo = this.videoResolve.video
    this.videos = this.videoResolve.videos.filter(
      c => c.videoID != this.currentVideo.videoID
    )
    this.isLoaded = true
  }
  goToGallery() {
    this.$router.push({ name: 'Gallery' })
  }
  async goToMedia(a: string) {
    this.isLoaded = false
    this.$router.push({ name: 'GalleryFile', params: { id: a } })
    await this.getVideos()

    this.isLoaded = true
  }
  public formatDate(value: string) {
    return moment(value).format('MM/DD/YYYY')
  }
}
